import React, { ReactElement } from 'react'

import ResponsiveSheet from '../ResponsiveSheet'
import styled from 'styled-components'

interface ContainerProps {
    onClose: () => void
    url: string
}

const Container = ({ onClose, url }: ContainerProps): ReactElement => {
    return (
        <div className="h-full">
            <ResponsiveSheet onClose={onClose}>
                <Frame
                    src={url}
                    height="100%"
                    width="100%"
                    data-testid="compliance-frame"
                />
            </ResponsiveSheet>
        </div>
    )
}

const Frame = styled.iframe`
    height: 90vh;
    border: none;
`

export default Container
